module.exports = __webpack_public_path__ + "static/media/odyssey-desktop.a7727f84.jpg";